import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import _ from 'lodash';
import { setCurrentWorkspaceCustomersIds } from '../slices/currentWorkspace';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';

export const getCustomersByWorkspace = createAsyncThunk(
  'customers/getCustomersByWorkspace',
  async (payload, { dispatch }) => {
    const { workspaceId } = payload;
    const workspaceCustomers = await api.customer.getCustomers({
      filter: {
        and: { workspaceId: { eq: workspaceId } },
      },
    });

    dispatch(
      setCurrentWorkspaceCustomersIds(
        workspaceCustomers.data.getCustomers.customers.map(
          (customer) => customer.id
        )
      )
    );
    return workspaceCustomers.data.getCustomers.customers;
  }
);

export const getCustomerById = createAsyncThunk(
  'customer/getCustomerById',
  async (payload) => {
    const customer = await api.customer.getCustomerById({
      customerId: payload,
    });

    return customer.data.getCustomerById;
  }
);

export const createNewCustomer = createAsyncThunk(
  'customer/createNewCustomer',
  async (payload) => {
    const { data } = payload;

    const newCustomer = await api.customer.createCustomer({
      data,
    });

    return newCustomer.data.createCustomer;
  }
);

export const updateCustomerById = createAsyncThunk(
  'customer/editCustomer',
  async (payload) => {
    const { id, data } = payload;

    const updatedCustomer = await api.customer.updateCustomerById({
      id,
      data,
    });

    return updatedCustomer.data.updateCustomerById;
  }
);

export const deleteCustomerById = createAsyncThunk(
  'customer/deleteCustomer',
  async ({ customerId, deleteDevices = false }) => {
    const deletedCustomer = await api.customer.deleteCustomerById({
      id: customerId,
      deleteDevices,
    });

    return deletedCustomer.data.deleteCustomerById;
  }
);

export const sendCustomerInvitation = createAsyncThunk(
  'customers/sendCustomerInvitation',
  async (payload) => {
    const { email, customerName, customerId, deviceIds = [], roleId } = payload;
    const response = await api.invitations.sendCustomerInvitation({
      customerId,
      invitation: {
        email,
        resourceName: customerName,
        deviceIds,
        roleId,
      },
    });

    return response.data.sendCustomerInvitation;
  }
);

export const acceptCustomerInvitation = createAsyncThunk(
  'customers/acceptCustomerInvitation',
  async (payload) => {
    const { token } = payload;
    const response = await api.invitations.acceptCustomerInvitation({
      token,
    });

    return response.data.acceptInvitation;
  }
);

export const rejectCustomerInvitation = createAsyncThunk(
  'customers/rejectCustomerInvitation',
  async (payload) => {
    const { token } = payload;
    const response = await api.invitations.rejectInvitation({
      token,
    });

    return response.data.rejectInvitation;
  }
);

export const updateCustomerImage = createAsyncThunk(
  'customers/updateCustomerImage',
  async (payload) => {
    const { file } = payload;
    const pictureName = `${uuidv4()}.webp`;

    const { data } = await api.upload.getUploadUrl({
      filename: pictureName,
    });

    const options = {
      // maxWidthOrHeight: 200,
      useWebWorker: true,
      fileType: 'image/webp',
    };

    const compressedImage = await imageCompression(file, options);

    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': compressedImage.type,
      },
      mode: 'cors',
      body: compressedImage,
    };

    const uploadToS3Response = await fetch(
      data?.getUploadSignedUrl?.url,
      requestOptions
    );

    if (uploadToS3Response.ok) {
      return pictureName;
    } else {
      throw new Error('Error uploading image');
    }
  }
);
